import apiUrl from '../../../constants';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'srTrackingWeb',
  components: {
    VueElementLoading,
  },
  mixins:[],
  data: function() {
    return {
      userDataKey: '',
      userToken: '',
      tmsRedirectUrl: ''
    }
  },
  mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    this.userToken = window.localStorage.getItem('lmUserToken');
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    const queryParams = new URLSearchParams({
      'LoginHubID': this.localhubdetails,
      'TrackType': 'LM',
    });
    // https://stagetmsapp.xbees.in/#/VehicleApprovalRequest?LoginHubIDName=PNQ/HUB(212)&TrackType=LM
    this.tmsRedirectUrl = `${apiUrl.tmsApp_url}/#/VehicleApprovalRequest?${queryParams.toString()}`;
  },
  methods: {
    redirectToTMSPortal(){
      window.open(this.tmsRedirectUrl);
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/components/vehicleAdhocRequests/vehicleAdhocRequests.component.js